import { Service, inject } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {GoogleService} from "./google-service";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Factor} from "../model/factor";
import {BrandID} from "../enums/brand-id";

@Service()
export class FactorService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'factor/';

  getActiveFactors(brandID: BrandID): Observable<Factor[]> {
    const url = this.urlBase + 'activefactors/' + brandID;
    return this.http.get<Factor[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
